import { BfxBlotterOrdersContextMenuState } from "./BfxBlotterOrdersContextMenuState";
import { BfxBlotterOrdersContextMenuItem } from "./BfxBlotterOrdersContextMenuItem";

import { BfxBlotterAction } from "../bfx-base-blotter/BfxBlotterAction";

import { ContextMenuItemState } from "../ContextMenuItemState";
import { ContextMenuItemStateCommand } from "../ContextMenuItemStateCommand";
import { ContextMenuItemStateCommandCriteria } from "../ContextMenuItemStateCommandCriteria";
import { ContextMenuState } from "../ContextMenuState";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BfxBlotterOrdersContextMenuItemTransferAbortState } from "./BfxBlotterOrdersContextMenuItemTransferAbortState";
import { OrderPauseState } from "shared/cubiq-services/model/orders/OrderPauseState";

export class BfxBlotterOrdersContextMenuTransferAbortItem extends BfxBlotterOrdersContextMenuItem {
  constructor() {
    super(
      BfxBlotterAction.ACTION_ABORT_TRANSFER,
      "Abort Transfer",
      BfxBlotterOrdersContextMenuTransferAbortItem.checkAvailableFn(),
      BfxBlotterOrdersContextMenuTransferAbortItem.checkEnabledFn(),
      ContextMenuItemStateCommandCriteria.Item,
      ContextMenuItemStateCommandCriteria.Item,
    );
  }

  public reset(): void {
    let oldState = this.state;
    this.state = new BfxBlotterOrdersContextMenuItemTransferAbortState();
    this.state.title = oldState.title;
  }

  private static checkAvailableFn(): ContextMenuItemStateCommand<CubiqTS.OrderDataImpl> {
    return function (
      this: void,
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: ContextMenuItemState,
      _item: CubiqTS.OrderDataImpl,
    ) {
      itemState.available = menuState.canTransfer || menuState.canTransferUnrestricted;
    };
  }

  private static checkEnabledFn(): ContextMenuItemStateCommand<CubiqTS.OrderDataImpl> {
    return function (
      this: void,
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: BfxBlotterOrdersContextMenuItemTransferAbortState,
      item: CubiqTS.OrderDataImpl,
    ) {
      if (!item) {
        itemState.enabled = false;
      } else {
        itemState.enabled =
          itemState.enabled && BfxBlotterOrdersContextMenuTransferAbortItem.checkOrderState(item);
        itemState.enabled =
          itemState.enabled &&
          BfxBlotterOrdersContextMenuTransferAbortItem.checkMembership(item, menuState, itemState);
      }

      itemState.count++;
    };
  }

  private static checkMembership(
    item: CubiqTS.OrderDataImpl,
    menuState: BfxBlotterOrdersContextMenuState,
    itemState: BfxBlotterOrdersContextMenuItemTransferAbortState,
  ): boolean {
    const srcTraderGroup: CubiqTS.TradingGroupImpl = menuState.traderGroups.get(
      item.deskId.toString(),
    );
    const targetTraderGroup: CubiqTS.TradingGroupImpl = menuState.traderGroups.get(
      item.targetDeskId.toString(),
    );

    // A transfer is covered by EXTERNAL_ABORT role if it's in TRANSFER_ACCEPTANCE and coming from or going to
    // an external group
    const externalAcceptance: boolean =
      srcTraderGroup &&
      targetTraderGroup &&
      (srcTraderGroup.isExternallyFilledFg || targetTraderGroup.isExternallyFilledFg);

    if (externalAcceptance) {
      // Group membership is not required for external abort, this lets Sales users
      // also abort external transfers
      return menuState.canAbortExternalTransfer;
    }

    let enabled: boolean = menuState.canTransferUnrestricted;
    if (!enabled) {
      // For trader check if order is in trader group and not owned by external
      if (
        menuState.activeUser.userTypeId == CubiqTS.UserType.TRADER &&
        item.deskId != null &&
        menuState.traderGroups.has(item.deskId.toString()) &&
        !menuState.canTransferUnrestricted
      ) {
        enabled = menuState.activeUser.tradingGroupsIdSet.has(item.deskId.toString());
      }
    }

    return enabled;
  }

  private static checkOrderState(item: CubiqTS.OrderDataImpl): boolean {
    return item.targetDeskId != null;
  }

  public static get state(): any {
    return new BfxBlotterOrdersContextMenuItemTransferAbortState();
  }
}
